import { Deserializable } from '../protocols/deserializable';

export class RoleUser implements Deserializable {
  public id!: number;
  public firstName!: string;
  public lastName!: string;
  public email!: string;

  onDeserialize(): void {}
}
